import React, { useRef, useState, useCallback, useEffect } from 'react';
import ZipcodePopover from '../_cart/zipcode-popover';
import classNames from 'classnames';
import {
  shouldStripPostalCodeWhitespace,
  isPostalCodeLocal
} from '../_utils/validations';
import PropTypes from 'prop-types';


function ZipCodeSection({
  zipCode,
  zipCodeValid,
  findCollectionLocations,
  saveZipCodeChange,
}) {
  const postalCodeInputRef = useRef(null);
  const [hideButton, setHideButton] = useState(true);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [zipCodeValidity, setZipCodeValidity] = useState(zipCodeValid);
  const [zipCodeState, setZipCodeState] = useState(zipCode);

  useEffect(() => {
    if (popoverOpen && postalCodeInputRef.current) {
      postalCodeInputRef.current.focus();
      postalCodeInputRef.current.select();
    }
  }, [popoverOpen]);

  useEffect(() => {
    if (zipCodeValid) {
      setZipCodeValidity(true);
    }
  }, [zipCodeValid]);

  // if invalid zipcode show popup and button to change runs first time
  useEffect(() => {
    const initialZipCodeValid = isPostalCodeLocal(zipCodeState);
    setZipCodeValidity(initialZipCodeValid);

    if (!zipCodeValid) {
      setPopoverOpen(true);
      setHideButton(false);
    }
  }, []);

  const togglePopover = useCallback((e) => {
    e.preventDefault();
    setPopoverOpen((prev) => !prev);
  }, []);

  const handleZipCodeChange = (event) => {
    const value = event.target.value;
    setZipCodeState(value);
    if (isPostalCodeLocal(value)) {
      setZipCodeValidity(true);
    }
  };

  const handleZipCodeUpdateClick = () => {
    let updatedZipCode = zipCodeState;
    if (shouldStripPostalCodeWhitespace()) {
      updatedZipCode = updatedZipCode.replace(/ /g, '');
    }
    saveZipCodeChange(updatedZipCode);
    setPopoverOpen(false);
    setHideButton(true);
    findCollectionLocations(updatedZipCode);
  };

  const handleZipCodeKeyUp = (event) => {
    if (event.key === 'Enter' && zipCodeValidity) {
      handleZipCodeUpdateClick();
    }
  };

  const handleZipCodeCancelClick = useCallback(() => {
    setPopoverOpen(false);
  }, []);

  const popperOptions = {
    modifiers: [
      {
        name: 'flip',
        enabled: false,
      },
    ],
  };

  return (
    <>
      <ZipcodePopover
        onRef={(el) => (postalCodeInputRef.current = el)}
        popoverOpen={popoverOpen}
        zipCodeValid={zipCodeValidity}
        zipCode={zipCodeState}
        handleZipCodeChange={handleZipCodeChange}
        handleZipCodeKeyUp={handleZipCodeKeyUp}
        handleZipCodeUpdateClick={handleZipCodeUpdateClick}
        handleZipCodeCancelClick={handleZipCodeCancelClick}
        popperOptions={popperOptions}
        shouldInputAutofocus={true}
      />
      <button
        className={classNames(
          'text-start btn-change',
          { 'd-none': hideButton
        })}
        onClick={togglePopover}
        id="popover-anchor">
        Change
      </button>
    </>
  );
}

ZipCodeSection.propTypes = {
  zipCode: PropTypes.string,
  zipCodeValid: PropTypes.bool,
  findCollectionLocations: PropTypes.func,
  saveZipCodeChange: PropTypes.func,
};

export default ZipCodeSection;
